/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { ColumnProps } from "~/components/Tables/types";
import { Tool } from "~/models";
import { ROUTES } from "~/routing";
import { displayYesOrNo } from "~/tools";

export const ToolListColumns: ColumnProps<Tool>[] = [
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
    width: "100%",
    Cell: ({ row }) => {
      const toolId = row.original.id;

      return (
        <Link
          css={{ color: theme.color.text.text01 }}
          to={`${ROUTES.tool.index}/${toolId}/`}
        >
          {row.original?.name}
        </Link>
      );
    },
  },
  {
    Header: "Internal",
    accessor: "internal",
    disableSortBy: true,
    Cell: ({ row }) => {
      const isInternal = row?.original?.internal;

      return (
        <FlexContainer justify="center" align="center">
          {displayYesOrNo(isInternal)}
        </FlexContainer>
      );
    },
  },
];
